export type Action = "READ" | "WRITE" | "SHARE" | "PUBLISH";

export interface TeamMember {
  id: string;
  actions: Action[];
}

export function hasWritePermission(actions?: Action[]) {
  return Boolean(actions?.includes("WRITE"));
}
